// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CwMSgi0gA7VaRj6VKcAg{border-color:#4a1e69;background:#4a1e69}`, "",{"version":3,"sources":["webpack://./../../../tools/nodeParticleEditor/dist/graphSystem/display/updateDisplayManager.module.scss"],"names":[],"mappings":"AAAA,sBACI,oBAAA,CACA,kBAAA","sourceRoot":""}]);
// Exports
var _1 = `CwMSgi0gA7VaRj6VKcAg`;
export { _1 as "update-display" };
export default ___CSS_LOADER_EXPORT___;
